import React, { Component } from "react";

import { connect } from "react-redux";
import { } from "../../store/actions";

//Simple bar
import SimpleBar from "simplebar-react";

import SidebarContent from "./SidebarContent";


class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {user} = this.props
        return (
            <React.Fragment>
                <div className="vertical-menu" onClick={this.props.onClick}>
                    <div className="h-100">
                        {this.props.type !== "condensed" ? (
                            <SimpleBar style={{ maxHeight: "100%" }}>
                                {user && <SidebarContent userRole={user?.role}/>}
                            </SimpleBar>
                        ) : <SidebarContent />}
                        {/*<SideBarContainerNew />*/}
                    </div>

                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout,
        user: state.Login.user
    };
};
export default connect(mapStatetoProps, {})(Sidebar)
